import React from "react";
import OverTimeChart1 from "../../../../components/question-components/charts/OverTimeChart1";
import OverTimeChart2 from "../../../../components/question-components/charts/OverTimeChart2";
import OverTimeChart3 from "../../../../components/question-components/charts/OverTimeChart3";
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/perfomance-styles/QuestionOverTime.css";

const QuestionOverTime = () => {
  return (
    <div className="question-overtime-container">
      <div className="question-overtime-header">
        <h1>Question performance over time</h1>
        <p>
          The charts below show you your performance in the main question bank
          since the start of your account.
        </p>
      </div>

      <div className="chart-sections-container">
        <div className="chart-section">
          <h5>Cumulative average score</h5>
          <hr />
          <p>
            The chart below shows how your{" "}
            <span className="missing-word">score</span> has changed since you
            started answering questions. It is based on first attempts to allow
            meaningful comparisons with other users. If at any point you've
            reset your account the data will also have been reset.
          </p>
          <div className="chart-wrapper">
            <OverTimeChart1 />
          </div>
        </div>

        <div className="chart-section">
          <h5>Weekly aggregate average scores</h5>
          <hr />
          <p>
            This chart shows how your performance has changed over time using
            weekly aggregate average scores. Again it is based on first
            attempts.
          </p>
          <div className="chart-wrapper">
            <OverTimeChart2 />
          </div>
        </div>

        <div className="chart-section">
          <h5>Number of questions attempted</h5>
          <hr />
          <p>
            The number of questions you have attempted since the start of your
            subscription (or since you reset your account) is shown below.
          </p>
          <div className="chart-wrapper">
            <OverTimeChart3 />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionOverTime;
